module.exports = __webpack_public_path__ + "img/5-point.80b9d4c5.svg";